import { useFeatureFlag } from '@artic/ui/feature-flag';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { OperationCreate } from '../../features/operations/operation-create';

export const Route = createFileRoute('/operations/new')({
  staticData: {
    breadcrumb: 'New operation',
    layout: 'default',
  },
  component: OperationCreatePage,
});

function OperationCreatePage() {
  // Operations management is part of the planner suite.
  const enabled = useFeatureFlag('planner');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
      </div>
    );
  }

  return <OperationCreate partnerId={partnerId} />;
}
